//DashboardLayout.jsx
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const DashboardLayout = ({ includeNavbarAndFooter = true, children }) => {
  return (
    <div className='relative flex-grow bg-cyan-900 overflow-x-hidden'>
      {/* Conditionally include Navbar and Footer based on the prop */}
      {includeNavbarAndFooter && (
        <>
          <Navbar />
           {children}
           <Footer />
        </>
      )}
      {/* Only include children if Navbar and Footer are excluded */}
      {!includeNavbarAndFooter && children}
    </div>
  );
};

export default DashboardLayout;
